import React from "react";
import { ImCheckboxUnchecked } from "react-icons/im";
import { BiPlus } from "react-icons/bi";
import { AiFillCaretDown } from "react-icons/ai";
import { HiMenuAlt1 } from "react-icons/hi";
import meterImg from "../../ImagesComponents/bannerImg/meter.jpg";
import graphImg from "../../ImagesComponents/bannerImg/graph.jpg";
// import keywordImgs1 from "../../ImagesComponents/all-images/keyword_img2.jpg";
// let keywordImgs = [
//   "https://ezmarketingtech.s3.amazonaws.com/img/keyword_img.jpg",
// ];
const KeywordsResearch = () => {
  return (
    <>
      <section className="keywords_research">
        <div className="container">
          <h2>
            <strong>Idea About Keywords Research As Per CBD Industry</strong>
          </h2>
          <p className="mb-5">
            <strong> Search Intent- </strong> The first parameter to analyze
            while selecting CBD keywords is search intent. If the content
            doesn’t include the keyword that matches the intent of users, users 
            will immediately close the site. So, you need to include key phrases
            that serve signals that the users are ready to buy. Here are some
            examples:{" "}
          </p>
          <p>
            <strong>“Best CBD Oil”</strong>- This phrase is used by those who
            are interested in buying the best CBD oils. Hence, the chance that
            this user is interested in purchasing CBD oil is quite high.{" "}
          </p>{" "}
          <p>
            {" "}
            <strong>“What is CBD Oil” </strong> - As you can see from the
            phrase, the user does not know what CBD oil is. Therefore, this user
            is interested in CBD oil, however, may not be ready to buy it.
            Attracting such users might need some extra efforts— they might
            become buyers later.{" "}
          </p>{" "}
          <p className="mb-5">
            <strong>“How long does cannabis stay in the body” </strong> - the
            user has already acquired marijuana and needs information. There is
            even a probability that they will not want to use cannabis products
            in the near future. It is a good keyword for a blog, but not for a
            commercial page. Informational blog pages are crucial to generate
            quality backlinks, which will improve your domain rating (DR).{" "}
          </p>
          <p>
            <strong> Search Volume </strong>- This parameter is based on the
            search statistic for particular key phrases. It is necessary to
            select the best CBD keywords with a high search volume and include
            them in your content to rank your website higher. But everything is
            not that simple in SEO, especially if you are working in the
            cannabis business.
          </p>
          {/* <img src={keywordImgs[0]} alt="img" height="562px" width="1280px" /> */}
          <section className="cbt_section">
            <div className="container">
              <div className="cbt_wrapper">
                <div className="row">
                  <div className="col-12 ">
                    <div className="cbt_header">
                      <p className="overview">
                        <strong>
                          <HiMenuAlt1 /> overview: cbd gummies
                        </strong>
                        <span> How To use</span>
                      </p>
                      <div>
                        <span>
                          SERP & KD updated 12 haurs ago.{" "}
                          <strong>update</strong>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-12  mt-4">
                    <div className="row">
                      <div className="col-5">
                        <div className="meter">
                          <p>Keyword Difficulty</p>
                          <div className="meter_image">
                            <img src={meterImg} alt="" width="100%" />
                          </div>
                          <p>
                            We estimate that You'll need backlinks from <br />
                            ~756 websites to rank in the top 10
                            <br />
                            for this Keyword
                          </p>
                        </div>
                      </div>
                      <div className="col-4">
                        <div className="graph_header">
                          <p>
                            {" "}
                            Volume <strong>358k</strong>
                          </p>
                          <ul className="dots">
                            <li></li>
                            <li></li>
                            <li></li>
                          </ul>
                        </div>
                        <div className="graph_image">
                          <img src={graphImg} alt="" width="100%" />
                        </div>
                        <div className="graph_subline">
                          <p>Clicks</p>
                          <span>322k</span>
                        </div>
                        <div className="graph_subline">
                          <p>Cost Per Click</p>
                          <span>$0.20</span>
                        </div>
                        <div className="graph_subline">
                          <p>Click per search</p>
                          <span>0.90</span>
                        </div>
                      </div>
                      <div className="col-3">
                        <div className="potentai_main">
                          <div className="potentai">
                            <p>
                              Traffic Potentail <strong> 74k</strong>
                            </p>
                          </div>

                          <div>
                            <p>Top ranking result</p>
                            <span className="show_url">
                              https://www.healthline.com/health/best-cbd-gummies
                            </span>
                          </div>
                          <div>
                            <p>parent Topic</p>
                            <p>Cbd gummies</p>
                            <p>Volume 358k</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <p>
            <strong>Keyword Difficulty </strong>- SEO experts in the CBD niche
            know how to select relevant SEO keywords that might help a CBD
            business thrive, irrespective of the general SEO optimization rules.
            Even though such keywords are hard to find, if you manage to find
            them, they will bring you qualified leads. These search terms have
            high search volume among users; however, their keyword-difficulty
            parameter is low. Getting help from a real professional might also
            help find these keywords.
          </p>
          <div className="keywords_research_table_wrapper table-responsive">
            <div className="total_valume">
              <strong>4,880 keywords</strong> Total Volume:415K
            </div>
            <table className="table table-bordered table-hover cbd_table">
              <thead>
                <tr>
                  <th>
                    <ImCheckboxUnchecked /> Keywords
                  </th>
                  <th>KD</th>
                  <th>
                    Volume <AiFillCaretDown />
                  </th>
                  <th>GV</th>
                  <th>TP</th>
                  <th>CPC</th>
                  <th>CPS</th>
                  <th>Parent topic</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <ImCheckboxUnchecked /> <BiPlus />{" "}
                    <span className="keyword_color">cbd oil nordic oil</span>
                  </td>
                  <td>
                    <span className="bg_green">8</span>
                  </td>
                  <td>13K</td>
                  <td>15K</td>
                  <td>12K</td>
                  <td>N/A</td>
                  <td>N/A</td>
                  <td>
                    <span className="keyword_color">cbd oil nordic oil</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <ImCheckboxUnchecked /> <BiPlus />{" "}
                    <span className="keyword_color">gold bee buy cbd oil</span>
                  </td>
                  <td>
                    <span className="bg_green bg_orange">22</span>
                  </td>
                  <td>7.5K</td>
                  <td>68K</td>
                  <td>29K</td>
                  <td>N/A</td>
                  <td>N/A</td>
                  <td>
                    <span className="keyword_color">cbd gold bee</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <ImCheckboxUnchecked /> <BiPlus />{" "}
                    <span className="keyword_color">cbd oil gold bee</span>
                  </td>
                  <td>
                    <span className="bg_green">5</span>
                  </td>
                  <td>7.4K</td>
                  <td>82K</td>
                  <td>30K</td>
                  <td>N/A</td>
                  <td>N/A</td>
                  <td>
                    <span className="keyword_color">cbd gold bee</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <ImCheckboxUnchecked /> <BiPlus />{" "}
                    <span className="keyword_color">
                      {" "}
                      gold bee cbd oil for sale
                    </span>
                  </td>
                  <td>
                    <span className="bg_green">5</span>
                  </td>
                  <td>7.0K</td>
                  <td>90K</td>
                  <td>30K</td>
                  <td>N/A</td>
                  <td>N/A</td>
                  <td>
                    <span className="keyword_color">cbd gold bee</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <ImCheckboxUnchecked /> <BiPlus />{" "}
                    <span className="keyword_color">
                      {" "}
                      best cbd oil nordic oil
                    </span>
                  </td>
                  <td>
                    <span className="bg_green">3</span>
                  </td>
                  <td>5.3K</td>
                  <td>6.1K</td>
                  <td>12K</td>
                  <td>N/A</td>
                  <td>N/A</td>
                  <td>
                    <span className="keyword_color">cbd oil nordic oil</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <ImCheckboxUnchecked /> <BiPlus />{" "}
                    <span className="keyword_color"> cbd cream nordic oil</span>
                  </td>
                  <td>
                    <span className="bg_green">8</span>
                  </td>
                  <td>4.7K</td>
                  <td>5.7K</td>
                  <td>1.7K</td>
                  <td>N/A</td>
                  <td>N/A</td>
                  <td>
                    <span className="keyword_color">cbd cream nordic oil</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <ImCheckboxUnchecked /> <BiPlus />{" "}
                    <span className="keyword_color">
                      {" "}
                      cbd product nordic oil
                    </span>
                  </td>
                  <td>
                    <span className="bg_green">8</span>
                  </td>
                  <td>4.4K</td>
                  <td>5.3K</td>
                  <td>12K</td>
                  <td>N/A</td>
                  <td>N/A</td>
                  <td>
                    <span className="keyword_color">cbd oil nordic oil</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <ImCheckboxUnchecked /> <BiPlus />{" "}
                    <span className="keyword_color"> cbd massage oil</span>
                  </td>
                  <td>
                    <span className="bg_green bg_orange">20</span>
                  </td>
                  <td>4.3K</td>
                  <td>6.4K</td>
                  <td>3.9K</td>
                  <td>$0.70</td>
                  <td>1.40</td>
                  <td>
                    <span className="keyword_color">cbd massage oil</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <ImCheckboxUnchecked /> <BiPlus />{" "}
                    <span className="keyword_color"> gold bee cbd oil</span>
                  </td>
                  <td>
                    <span className="bg_green">12</span>
                  </td>
                  <td>4.2K</td>
                  <td>72K</td>
                  <td>29K</td>
                  <td>N/A</td>
                  <td>N/A</td>
                  <td>
                    <span className="keyword_color">cbd gold bee</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          {/* <img src={keywordImgs[1]} alt="img" height="562px" width="1280px" /> */}
        </div>
      </section>
    </>
  );
};

export default KeywordsResearch;
